export const WARNING_EXPIRATION_IN_HOURS = 12;
export const DEFAULT_WARNING_ICON = '/static/warning-icons/checked-profile.svg';

export const POINTS = {
  code: 'WARN-1',
  icon: '/static/warning-icons/checked-profile.svg',
};

export const BGCHECK = {
  code: 'WARN-2',
  icon: '/static/warning-icons/money-bag.svg',
};

export default {
  'WARN-1': POINTS,
  'WARN-2': BGCHECK,
};

// BANNED: 'PERM-1',
// COMPLIANCE: 'PERM-2',
// INACTIVE: 'PERM-4',
// REWARDS: 'PERM-5',
// ONBOARDING: 'PERM-6',
// POINTS: 'PERM-7',
// PENDING_ID_VERIFICATION___LEGACY: 'PERM-8',
